
export const DrawScope = {
  Normal: 0,
  Debug: 1,
};
